// API bindings: chatbot (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler } from "@asanrom/request-browser";
import { getApiUrl, generateURIQuery } from "./utils";
import { ChatbotMessagesResponse, SendChatbotMessageRequest, EditSectionRequest } from "./definitions";

export class ApiChatbot {
    /**
     * Method: GET
     * Path: /chatbot
     * Get paginated chatbot messages for the authenticated user
     * @param queryParams Query parameters
     * @returns The request parameters
     */
    public static GetChatbotMessages(queryParams: GetChatbotMessagesQueryParameters): RequestParams<ChatbotMessagesResponse, CommonAuthenticatedErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/chatbot` + generateURIQuery(queryParams)),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /chatbot
     * Send a chatbot message
     * @param body Body parameters
     * @returns The request parameters
     */
    public static SendChatbotMessage(body: SendChatbotMessageRequest): RequestParams<void, SendChatbotMessageErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/chatbot`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(400, "MESSAGE_TOO_LONG", handler.badRequestMessageTooLong)
                    .add(400, "MESSAGE_REQUIRED", handler.badRequestMessageRequired)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /chatbot
     * Delete all chatbot messages for the authenticated user
     * @returns The request parameters
     */
    public static DeleteChatbotMessages(): RequestParams<void, CommonAuthenticatedErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/chatbot`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /chatbot/edit-section
     * Edit a report section via AI
     * @param body Body parameters
     * @returns The request parameters
     */
    public static EditSection(body: EditSectionRequest): RequestParams<void, EditSectionErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/chatbot/edit-section`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(400, "REPORT_ID_REQUIRED", handler.badRequestReportIdRequired)
                    .add(400, "SECTION_ID_REQUIRED", handler.badRequestSectionIdRequired)
                    .add(400, "MESSAGE_TOO_LONG", handler.badRequestMessageTooLong)
                    .add(400, "MESSAGE_REQUIRED", handler.badRequestMessageRequired)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}

/**
 * Query parameters for GetChatbotMessages
 */
export interface GetChatbotMessagesQueryParameters {
    /**
     * Page number (default 1)
     */
    page?: number;
}

/**
 * Error handler for SendChatbotMessage
 */
export type SendChatbotMessageErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = MESSAGE_REQUIRED
     */
    badRequestMessageRequired: () => void;

    /**
     * Handler for status = 400 and code = MESSAGE_TOO_LONG
     */
    badRequestMessageTooLong: () => void;
};

/**
 * Error handler for EditSection
 */
export type EditSectionErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = MESSAGE_REQUIRED
     */
    badRequestMessageRequired: () => void;

    /**
     * Handler for status = 400 and code = MESSAGE_TOO_LONG
     */
    badRequestMessageTooLong: () => void;

    /**
     * Handler for status = 400 and code = SECTION_ID_REQUIRED
     */
    badRequestSectionIdRequired: () => void;

    /**
     * Handler for status = 400 and code = REPORT_ID_REQUIRED
     */
    badRequestReportIdRequired: () => void;
};

